<div class="mb-2 cursor d-flex align-items-center gap-3" (click)="hide = !hide">
  <div class="fw-bold">Інструкція використання мобільного додатку DiaCard</div>
  <i class="bi fw-bold fs-3" [ngClass]="{ 'bi-chevron-down': hide, 'bi-chevron-up': !hide }"></i>
</div>
@if(!hide){
<section class="mb-5">
  <h2>Для лікаря</h2>
  <p>
    Мобільний додаток DiaCard можна налаштувати для передачі зареєстрованих Електрокардіограм у Інформаційну систему
    oranta-mis.com Клініки, модуль Теледіагностика. Для цього потрібно встановити мобільний додаток DiaCard, і провести
    Налаштування профіля Лікаря та Клініки
  </p>
  <div class="row">
    <div class="col-lg-3 col-md-6 d-flex flex-column align-items-center">
      <img
        src="images/solvaig-instruction/screenshot_1.jpg"
        alt="screenshot_2"
        class="img-fluid border rounded screenshot"
      />
      <p>Потрібно обрати поле з 3-ма рисками</p>
    </div>
    <div class="col-lg-3 col-md-6 d-flex flex-column align-items-center">
      <img
        src="images/solvaig-instruction/screenshot_2.jpg"
        alt="screenshot_2"
        class="img-fluid border rounded screenshot"
      />
      <p>Обрати назву клініки в зеленому полі</p>
    </div>
    <div class="col-lg-3 col-md-6 d-flex flex-column align-items-center">
      <img
        src="images/solvaig-instruction/screenshot_3.jpg"
        alt="screenshot_3"
        class="img-fluid border rounded screenshot"
      />
      <p>
        В списку Лікарів, що відкрився потрібно додати Лікаря або вибрати зі списку, натиснути і утримати декілька
        секунд на потрібній назві з подальшим вибором редагувати
      </p>
    </div>
    <div class="col-lg-3 col-md-6 d-flex flex-column align-items-center">
      <img
        src="images/solvaig-instruction/screenshot_4.jpg"
        alt="screenshot_4"
        class="img-fluid border rounded screenshot"
      />
      <p>
        У картці Лікаря, Потрібно внести назву клініки та її ІД (номер клініки) в дужках - наприклад (4), та Ваші ПІП та
        ІД (номер) в дужках - наприклад (3), те що відображається у Вашому профілі, таку саму поштову адресу та телефон,
        що використовувалась при реєстрації на порталі oranta-mis.com в якості працівника.
      </p>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12 my-3 d-flex flex-column align-items-center">
      <h4>Налаштування адреси надсилання результатів вимірювання</h4>
    </div>
    <div class="col-md-6 d-flex flex-column align-items-center">
      <img
        src="images/solvaig-instruction/screenshot_1.jpg"
        alt="screenshot_1"
        class="img-fluid border rounded screenshot"
      />
      <p>Потрібно натиснути на поле Параметри ЕКГ</p>
    </div>
    <div class="col-md-6 d-flex flex-column align-items-center">
      <img
        src="images/solvaig-instruction/screenshot_5.jpg"
        alt="screenshot_5"
        class="img-fluid border rounded screenshot"
      />
      <p>
        У вкладці Параметри ЕКГ має бути включений (положення праворуч) обрана вкладка Telecardian - буде підтримуватись
        функція при сплаті підписки. та має бути включена функція E-mail лікаря. потрібно внести поштову адресу
        support&#64;oranta-ao.com Всі інші налаштування можуть бути обрані самостійно, Для підтримки вимірювань ЕКГ
        тривалістю більше 20 хвилин потрібно узгодити зі службою підтримки info&#64;oranta-ao.com
      </p>
    </div>
  </div>

  <div class="row">
    <div class="col-md-12 my-3 d-flex flex-column align-items-center">
      <h4>
        Налаштування профіля Пацієнта для підтримки сервісів Теледіагностика у Інформаційній системі oranta-mis.com
      </h4>
      <p>
        Мобільний додаток DiaCard можна налаштувати для передачі зареєстрованих Електрокардіограм у Інформаційну систему
        oranta-mis.com Клініки, модуль Теледіагностика. Для цього потрібно встановити мобільний додаток DiaCard, і
        провести Налаштування профіля Лікаря та Клініки
      </p>
    </div>
    <div class="col-lg-3 col-md-6 d-flex flex-column align-items-center">
      <img
        src="images/solvaig-instruction/screenshot_1.jpg"
        alt="screenshot_1"
        class="img-fluid border rounded screenshot"
      />
      <p>Потрібно обрати поле з 3-ма рисками</p>
    </div>
    <div class="col-lg-3 col-md-6 d-flex flex-column align-items-center">
      <img
        src="images/solvaig-instruction/screenshot_2.jpg"
        alt="screenshot_2"
        class="img-fluid border rounded screenshot"
      />
      <p>Обрати Пацієнти</p>
    </div>
    <div class="col-lg-3 col-md-6 d-flex flex-column align-items-center">
      <img
        src="images/solvaig-instruction/screenshot_6.jpg"
        alt="screenshot_6"
        class="img-fluid border rounded screenshot"
      />
      <p>
        В списку Пацієнтів, що відкрився потрібно додати Пацієнта або вибрати зі списку, натиснути і утримати декілька
        секунд на потрібній назві з подальшим вибором редагувати
      </p>
    </div>
    <div class="col-lg-3 col-md-6 d-flex flex-column align-items-center">
      <img
        src="images/solvaig-instruction/screenshot_7.jpg"
        alt="screenshot_7"
        class="img-fluid border rounded screenshot"
      />
      <p>
        У картці Пацієнта, Потрібно внести ПІП та Ваші (Пацієнта) ПІП та ІД (номер) в дужках - наприклад (3), те що
        відображається у Вашому профілі, таку саму поштову адресу та телефон, що використовувалась при реєстрації на
        порталі oranta-mis.com в якості Пацієнта.
      </p>
    </div>
  </div>
</section>
}
